import { useUrlParams } from './useUrlParams';
import { useEffect, useState } from 'react';
import { Socket } from 'socket.io-client';
import { createSessionGatewayClient } from '../utils/spl-factory-backend/session';

export const useSessionGateway = () => {
    const { sessionId } = useUrlParams();

    const [sessionClient, setSessionClient] = useState<Socket>();

    useEffect(() => {
        if (sessionId) {
            const sessionSocket = createSessionGatewayClient(process.env.REACT_APP_MINT_TS_BACKEND!, process.env.REACT_APP_MINT_TS_BACKEND_APIKEY!, sessionId);

            sessionSocket.on('connect', () => console.debug('Automatization client connected', sessionSocket.id));
            sessionSocket.on('connect_error', () => console.debug('Automatization client connection error'));
            sessionSocket.on('disconnect', () => console.debug('Automatization client disconnected'));

            sessionSocket.connect();

            setSessionClient(sessionSocket);

            return () => {
                sessionSocket.off('connect');
                sessionSocket.off('connect_error');
                sessionSocket.off('disconnect');
                sessionSocket.disconnect();
            };
        }
    }, [sessionId]);

    return {
        sessionClient,
    };
};
